import gql from 'graphql-tag';

export default gql`
  query order($id: ID!) {
    order(id: $id) {
      id
      totalItemPrice
      subTotalBeforeVat
      totalVat
      totalVatOnProducts
      items {
        totalBeforeVat
        product {
          id
          nameLocal
          imageUrl
          uom
          uomLocal
        }
        total
        buyerNote
        deliveryQuantity
        orderedQuantity
        deliveredNote
        internalCode
        unitPriceAtOrderCreated {
          value
          vatIncluded
          vat
        }
        unitPriceAfterDiscount
        amountAfterDiscount
      }
      orderDate
      deliveryTime {
        start
        end
      }
      acceptedAt
      acceptedBy {
        id
        name
        email
        telephone
      }
      acceptedNote
      declinedAt
      declinedBy {
        id
        name
        email
        telephone
      }
      declinedNote
      status
      paymentMethod
      buyer {
        id
        name
        telephone
        location {
          city
          district
          address
        }
        redInvoiceInfo {
          companyName
          location {
            city
            district
            address
          }
          taxCode
        }
      }
      store {
        id
        name
        telephone
        location {
          address
          district
          ward
          city
        }
        newMergedLocation {
          city
          district
          address
          ward
        }
        recordId
        disabled
      }
      creator {
        id
        name
        email
        telephone
      }
      buyerNote
      total
      redelivery
      orderType
      discount
      deliveryFee {
        fee
        discount
        active
        additionalVat
      }
      zeroOrderInfo {
        reason
        receiver
        orderId
      }
      cancelledAudit {
        userName
        time
      }
      fulfillmentNote {
        id
        shortCode
        status
      }
      attachPos {
        path
        name
        type
        size
      }
    }
  }
`;
